import { render } from "./profileMenu.vue?vue&type=template&id=34e4ac78"
import script from "./profileMenu.vue?vue&type=script&lang=js"
export * from "./profileMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__